export const CATEGORIES = [
  {
    name: 'Position',
    qs: 'positions',
  },
  {
    name: 'Workplace',
    qs: 'workplaces',
  },
  {
    name: 'Age Range',
    qs: 'ageRange',
  },
  {
    name: 'Subject',
    qs: 'subjects',
  },
  {
    name: 'Contract term',
    qs: 'contractTerms',
  },
  {
    name: 'Contract type',
    qs: 'contractTypes',
  },
  {
    name: 'Salary range',
    qs: 'salaryRanges',
  },
  {
    name: 'Grade',
    qs: 'grades',
  },
  {
    name: 'Experience',
    qs: 'experiences',
  },
  {
    name: 'New / Expiring',
    qs: 'timing',
  },
];

// Refdata constance found in https://github.com/tes/refdata/blob/master/data/job-search-distance-interval.json
export const MAX_DISTANCE = [
  { id: '0', name: '3' },
  { id: '1', name: '5' },
  { id: '2', name: '10' },
  { id: '3', name: '15' },
  { id: '4', name: '20' },
  { id: '5', name: '30' },
  { id: '6', name: '50' },
  { id: '7', name: '70' },
  { id: '8', name: '100' },
  { id: '9', name: '500' },
];
